import { render, staticRenderFns } from "./EditTableButton.vue?vue&type=template&id=227408cf&"
import script from "./EditTableButton.vue?vue&type=script&lang=js&"
export * from "./EditTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports